<template>
  <header
    class="header-navigation h-auto bg-gradient-to-b from-white/100 to-white/60 t-0 w-[100%] hover:bg-white/100! transition-colors duration-200"
    :class="{ 'bg-white/90! ': menuOpen, 'bg-white': mobileMenuOpen }">

    <!-- :class="{ 'bg-white/90! ': !isAtTop || menuOpen } -->
    <PageContentCenter class="header-navigation-menu flex flex-wrap justify-between items-center">

      <NuxtLink to="/" class="logo-link hnhg-logo" aria-label="湖南和贵网络科技">
      </NuxtLink>

      <div class="max-ml:hidden">
        <template v-for="item in menu" :key="item.path">
          <!-- 有子菜单的项 -->
          <!-- :open-on-hover="!isMobile" :open-on-click="isMobile" -->
          <!-- open-on-hover -->
          <VMenu open-on-hover content-class="header-navigation-vmemu-cover" location="bottom start" origin="top start"
            transition="v-menu-custom-transition" v-if="item.children && item.children.length > 0"
            @update:modelValue="menuOpen = $event">
            <template #activator="{ props }">
              <VBtn v-bind="props" variant="text" class="nav-item text-16px!"
                :class="{ 'nav-item-active': isMenuActive(item) }" :ripple="false" @click="handleMenuClick(item)">
                {{ item.name }}
              </VBtn>
            </template>
            <VList class="product-menu-children max-h-[80%] relative">
              <PageContentCenter class="flex flex lg:flex-row">
                <VListItem class="max-w-[50%]  flex flex-col justify-between " v-for="child in item.children"
                  :key="child.path" :to="isExternalLink(child.path) ? undefined : child.path" :href="isExternalLink(child.path) ? child.path : undefined" @click="handleMenuClick(child, child.path)">
                  <div class="mb-23.04px pb-23.04px ">
                    <VListItemTitle class="mb-8px text-14.08px">{{ child.name }}</VListItemTitle>
                    <VListItemSubtitle class="text-12px h-16px">{{ child.desc }}</VListItemSubtitle>
                  </div>

                  <div class="product-menu-children-children" v-if="child.children">
                    <VListItem v-for="childProduct in child.children" :key="childProduct.id">
                      <text v-if="childProduct.disabled" class="text-#eee" disabled>
                        {{ childProduct.name }}
                      </text>
                      <NuxtLink v-else :to="childProduct.path ? childProduct.path : `/products/${childProduct.id}`"
                        :external="isExternalLink(childProduct.path ? childProduct.path : `/products/${childProduct.id}`)" class="product-link"
                        @click="handleChildClick(child, childProduct, childProduct.path ? childProduct.path : `/products/${childProduct.id}`)">
                        {{ childProduct.name }}
                      </NuxtLink>
                    </VListItem>
                  </div>
                </VListItem>
              </PageContentCenter>
            </VList>
          </VMenu>

          <!-- 没有子菜单的项 -->
          <VBtn v-else :to="isExternalLink(item.path) ? undefined : item.path" :href="isExternalLink(item.path) ? item.path : undefined" :target="isExternalLink(item.path) ? '_blank' : undefined" :rel="isExternalLink(item.path) ? 'noopener noreferrer' : undefined" variant="text" class="nav-item text-18.08px!"
            :class="{ 'nav-item-active': isMenuActive(item) }" :ripple="false" exact @click="handleMenuClick(item)">
            {{ item.name }}
          </VBtn>
        </template>
      </div>

      <div class="header-navigation-mobile hidden max-ml:block">
        <div @click="handleMobileMenuClick" class="header-navigation-mobile-top-icon p-0.5rem pl-1rem">
          <span class="w-1rem h-1rem inline-block"
            :class="{ 'header-navigation-mobile-icon-menu': !mobileMenuOpen, 'header-navigation-mobile-icon-close': mobileMenuOpen }"></span>
        </div>
        <div @click.stop @touchmove.stop.prevent class="header-navigation-mobile-menu fixed bg-white w-100vw"
          :class="{ 'header-navigation-mobile-menu--active': mobileMenuOpen }">
          <PerfectScrollbar class="w-100% h-100%">
            <ul v-show="mobileMenuOpen" class="px-1rem text-0.9rem w-100% pb-5rem">
              <li v-for="(out, index) in menu" :key="index" class="">
                <div>
                  <!-- 有path 是直接跳转的 -->
                  <NuxtLink :class="isCurrentMobileMenuOpen(out.path) ? 'bg-[#f0f0f0b3] rounded-2px text-#1967F9' : ''"
                    @click="handleMobileMenuClick" v-if="out.path" :to="out.path" :external="isExternalLink(out.path)"
                    class="active:bg-[#f0f0f0b3] p-0.8rem block">
                    <h4 class="flex justify-between items-center"
                      :class="isCurrentMobileMenuOpen(out.path) ? ' text-#1967F9' : ''">
                      <span>{{ out.name }}</span>
                      <Pic src="/images/mobile/header-right-arrow-time.png" class="w-1.5rem rotate-135" />
                    </h4>
                  </NuxtLink>
                  <!-- 没有path 是展开的 -->
                  <h4 @click="toggleMenu(index, out)" v-else class="flex justify-between p-0.8rem block items-center">
                    <span>{{ out.name }}</span>
                    <!-- origin-left -->
                    <Pic src="/images/mobile/header-right-arrow-time.png"
                      class="w-1.5rem block  transition-transform duration-300"
                      :class="activeIndex === index ? 'rotate-0' : 'rotate-135'" />
                  </h4>
                </div>

                <ul class="header-navigation-mobile-child"
                  :class="{ 'header-navigation-mobile-child--active': activeIndex === index }">
                  <li class="w-100%" v-for="(outItem, j) in out.children" :key="j">
                    <span class="pl-2.5rem text-#cdcdcd py-0.8rem inline-block">{{ outItem.name }}</span>
                    <ul class="children-li:last:pb-5rem mb-1.5rem">
                      <li v-for="(value, k) in outItem.children" :key="k" class="">
                        <NuxtLink
                          :class="isCurrentMobileMenuOpen(value.path) ? 'bg-[#f0f0f0b3] rounded-2px text-#1967F9' : ''"
                          @click="handleMobileMenuClick" v-if="!value.disabled" :to="value.path" :external="isExternalLink(value.path)"
                          class="active:bg-[#f0f0f0b3] p-0.8rem pl-2.5rem block">
                          <h4 :class="isCurrentMobileMenuOpen(value.path) ? ' text-#1967F9' : ''"
                            class="flex justify-between items-center">
                            <span>{{ value.name }}</span>
                            <Pic src="/images/mobile/header-right-arrow-time.png" class="w-1.5rem rotate-135" />
                          </h4>
                        </NuxtLink>
                      </li>
                    </ul>
                  </li>
                </ul>

              </li>
            </ul>
          </PerfectScrollbar>
        </div>
      </div>
    </PageContentCenter>
  </header>
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router'
// import heguiLogo from '@base/images/svg/logo.svg'
import type { Menu } from '../../stores/menu'
import { useMenuStore } from '../../stores/menu'
import { usePageLayoutStore } from '../../stores/layout'
import { ref, computed, onMounted } from 'vue'
const layoutStore = usePageLayoutStore()
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
const isAtTop = computed(() => layoutStore.isAtTop)
const inItemActive = ref(false)

const menuStore = useMenuStore()
const { menu } = menuStore
const route = useRoute()
const isCurrentMobileMenuOpen = (url) => {
  return url === route.path
}
const menuOpen = ref(false)
const mobileMenuOpen = ref(false)
const handleMobileMenuClick = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

// 当前展开的菜单 index
const activeIndex = ref(0)

const toggleMenu = (index, item) => {
  // 如果是 link 菜单，直接 return
  if (item.path) return
  activeIndex.value = activeIndex.value === index ? null : index
}

// 递归检查菜单项及其子项是否匹配当前路径
function isMenuItemActive(item: Menu, currentPath: string): boolean {
  // 直接匹配当前菜单项的路径
  if (item.path && item.path !== '/' && currentPath.startsWith(item.path)) {
    return true
  }
  return false
}

// 判断菜单是否激活
function isMenuActive(item: Menu) {
  const currentPath = route.path
  if (currentPath === item.path) return true

  // 使用递归函数检查菜单项是否激活
  return isMenuItemActive(item, currentPath)
}

// 判断是否为外链
function isExternalLink(path: string | undefined): boolean {
  return !!path && /^https?:\/\//i.test(path)
}

// 处理菜单项点击
function handleMenuClick(item: Menu, path?: string) {
  const targetPath = path || item.path || '/'
  // 外链直接跳转，不走路由存储
  if (isExternalLink(targetPath)) {
    window.open(targetPath, '_blank', 'noopener,noreferrer')
    return
  }
  menuStore.saveRoute(item, targetPath)
}

// 处理子菜单点击
function handleChildClick(parent: Menu, child: Menu, path: string) {
  // 外链直接跳转，不走路由存储
  if (isExternalLink(path)) {
    window.open(path, '_blank', 'noopener,noreferrer')
    return
  }
  menuStore.saveRoute({
    ...child,
    parent: parent,
  }, path)
}

// 组件挂载时恢复路由
onMounted(() => {
  menuStore.restoreRoute()
})
</script>
<style lang="scss" scoped>
@import "@base/@core/scss/template/libs/vuetify/variables";

.header-navigation-mobile {

  /* 新版 */
  .header-navigation-mobile-child {
    overflow: hidden;
    opacity: 0;
    pointer-events: none; // 防止未展开时可以点到
    transform: translateY(-6px);
    height: 0;


    transition:
      height 0.3s ease,
      opacity 0.25s ease,
      transform 0.25s ease;
  }

  .header-navigation-mobile-child--active {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    height: auto;
  }

  .header-navigation-mobile-menu {
    z-index: 9;
    top: $table-header-height;
    left: 0;
    width: 100vw;
    height: calc(100vh - $table-header-height);
    opacity: 0;
    // overflow: hidden;
    // overflow-y: scroll;
    pointer-events: none;
    transform: scaleY(0.95);
    transform-origin: top;
    transition:
      transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
      opacity 0.25s ease-out;
    will-change: transform, opacity;
    display: flex;
    // padding-bottom: 5rem;
  }

  .header-navigation-mobile-menu--active {
    opacity: 1;
    pointer-events: auto;
    transform: scaleY(1);
  }

  .header-navigation-mobile-icon-close {
    z-index: 9;
    background-image: url("/images/mobile/navigator-close.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    filter: invert(1);
  }

  .header-navigation-mobile-icon-menu {
    background-image: url("/images/mobile/navigator-menu.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    filter: invert(1);
  }
}

.hnhg-logo {
  width: 8.13rem;
  height: 1.9rem;
  background-image: url("/images/logo.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.header-navigation *,
.header-navigation *:focus,
.header-navigation *:active,
.header-navigation *:hover {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.header-navigation {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  transition: background-color 0.5s ease;

  .header-navigation-menu {
    display: flex;
    height: $table-header-height;
    flex-wrap: wrap; /// 移动端需要换行
    align-items: center;

    .nav-item {
      position: relative;
      margin: 0 1rem;
      font-weight: normal;

      // 移除 Vuetify 默认的所有状态样式
      &.v-btn {
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        color: #333 !important;
      }

      // 移除 Vuetify 按钮内容的默认颜色
      :deep(.v-btn__content) {
        color: #333 !important;
        font-size: 14px !important;
        font-weight: normal;
      }

      // 移除所有覆盖层效果
      :deep(.v-btn__overlay) {
        display: none !important;
        opacity: 0 !important;
      }

      // 移除下划线效果
      :deep(.v-btn__underlay) {
        display: none !important;
      }

      // 悬停效果
      &:hover {
        &.v-btn {
          background: transparent !important;
          background-color: transparent !important;
          color: rgb(var(--v-theme-primary)) !important;
        }

        :deep(.v-btn__content) {
          color: rgb(var(--v-theme-primary)) !important;
        }

        :deep(.v-btn__overlay) {
          opacity: 0 !important;
        }
      }

      // 选中状态样式
      &.nav-item-active,
      &.v-btn--active {
        &::before {
          display: none !important;
        }

        &.v-btn {
          background: transparent !important;
          background-color: transparent !important;
          color: rgb(var(--v-theme-primary)) !important;
        }

        :deep(.v-btn__content) {
          color: rgb(var(--v-theme-primary)) !important;
        }

        :deep(.v-btn__overlay) {
          background-color: transparent !important;
          opacity: 0 !important;
        }
      }

      // 底部小横线（伪元素实现）- 单独处理避免被覆盖
      &.nav-item-active::before,
      &.v-btn--active::before {
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 50%;
        width: 60%;
        height: 2px;
        border-radius: 1px;
        background-color: rgb(var(--v-theme-primary));
        content: "";
        transform: translateX(-50%);
      }

      // 移除焦点状态的背景
      &:focus,
      &:focus-visible,
      &:active {
        &.v-btn {
          background: transparent !important;
          background-color: transparent !important;
        }

        :deep(.v-btn__overlay) {
          opacity: 0 !important;
        }
      }
    }
  }
}

.product-link {
  display: block;
  width: 100%;
  color: inherit;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: rgb(var(--v-theme-primary));
  }
}

:deep(.header-navigation-vmemu-cover) {
  top: $table-header-height !important;
  left: 50% !important;
  max-width: 102vw !important;
  height: 420px;
  background-color: #f6f8fd;
  transform: translateX(-50%) !important;

  .v-list-item {
    width: 200px;
    flex: 1;
    align-items: start;

    // background: #f3f7ff;
    // padding-inline: 0 !important;
  }

  .product-menu-children {
    width: 100vw;
    max-width: $page-max-width;
    height: 420px;
    max-height: 80vh;
    padding: 0;
    background-color: #fff !important;
    box-shadow: none !important;

    >.page-content-center {
      height: 100%;
      padding: 32px;
      background-color: #fff;
    }

    .v-list-item__content {
      overflow: visible;
      align-items: start;
      align-self: start;
    }

    .v-list-item__overlay {
      opacity: 0 !important;
    }

    .v-list-item {
      padding-inline: 0;
    }

    .v-ripple__container {
      overflow: hidden;
      width: 0;
    }
  }

  .product-menu-children-children {
    border-radius: 6.08px;
    line-height: 40px;

    .v-list-item {
      box-sizing: border-box;
      padding-right: 12px;
      padding-left: 12px;
      color: #616671;
      font-size: 14.08px;

      &:hover {
        border-radius: 6.08px;
        background: #f3f7ff;
      }

      &:active {
        background: rgba($color: #333, $alpha: 5%);
        color: #a1a5b3;
      }
    }
  }
}

:deep(.v-menu-custom-transition-enter-active),
:deep(.v-menu-custom-transition-leave-active) {
  transition: opacity 0.3s ease, transform 0.3s ease;
  will-change: opacity, transform;
}

:deep(.v-menu-custom-transition-enter-from),
:deep(.v-menu-custom-transition-leave-to) {
  opacity: 0;
  transform: translateY(0.625rem);
}

.header-mobile-menu--active {
  background-color: rgba(0, 0, 0, 50%);
}
</style>